var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
var QuizController = /** @class */ (function () {
    function QuizController() {
    }
    /*****************************************************************************************************
        * Is using route "api/quiz/referenced/{groupId}" and http method "POST" to call the back-end.
    Adds correctly typed Question subclasses to quizDownloadDto based on quiz.QuestionIds.  Preserves order and blanks out solutions.
    
        * @param {string} groupId
        * @param {string[]} categoryIds
        * @returns {ExtendedDataCollection<QuizDownloadDto, string>}
    ******************************************************************************************************/
    QuizController.GetReferencedQuizzes = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("categoryIds", JSON.stringify(data.categoryIds));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/quiz/referenced/{groupId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/quiz/{groupid}" and http method "GET" to call the back-end.
    
        * @param {string} groupid
        * @returns {ExtendedDataCollection<QuizDownloadDto, string>}
    ******************************************************************************************************/
    QuizController.Get = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/quiz/{groupid}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/quiz/token/{groupid}" and http method "POST" to call the back-end.
    
        * @param {string} groupid
        * @param {TokenContainer} token
        * @returns {ExtendedDataCollection<PostDownloadDto, string>}
    ******************************************************************************************************/
    QuizController.GetPaged = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/quiz/token/{groupid}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.token
        });
    };
    /*****************************************************************************************************
        * Is using route "api/quiz/{id}/single" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @returns {QuizDownloadDto}
    ******************************************************************************************************/
    QuizController.GetSingle = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/quiz/{id}/single", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    return QuizController;
}());
export { QuizController };
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=QuizController.js.map